import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ConfirmationModal = ({ open, onConfirm, onClose, header, showAlertOnly, children }) => {
    return (
        <Modal open={open} onClose={onClose} size='tiny'>
            <Modal.Header>{header}</Modal.Header>
            <Modal.Content>{children}</Modal.Content>
            <Modal.Actions>
                {!showAlertOnly && <Button id="yesBtn" primary onClick={onConfirm}>Yes</Button>}
                {!showAlertOnly && <Button id="noBtn" primary onClick={onClose}>No</Button>}
                {showAlertOnly && <Button id="okBtn" primary onClick={onClose}>OK</Button>}
            </Modal.Actions>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    children: PropTypes.any
};

export default ConfirmationModal;